module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lgrPA"))).then(() => module.bundle.root('6TueN'));